import { ApolloClient } from '@apollo/client'
import {
  CurrentCustomerQuery,
  CurrentCustomerQueryDocument
} from 'queries/types/CurrentCustomerQuery'

export type { CurrentUserFragmentOld as CURRENT_USER_FRAGMENT } from 'queries/types/CurrentUserFragmentOld'
export { CurrentCustomerQueryDocument as QUERY } from 'queries/types/CurrentCustomerQuery'

type Args = {
  client: ApolloClient<object>
  fetchPolicy?: 'cache-first' | 'network-only'
}

export default async function getCurrentUser({
  client,
  fetchPolicy = 'cache-first'
}: Args): Promise<NonNullable<CurrentCustomerQuery['currentCustomer']> | null> {
  const result = await client.query<CurrentCustomerQuery>({
    query: CurrentCustomerQueryDocument,
    fetchPolicy
  })

  return result?.data?.currentCustomer
}
